export default __webpack_public_path__ + "static/media/kitchen4-afterB-480w.71e5b66b.webp";